<template>
	<div class="row">
		<div class="col-12 mb-4">
			<div class="row justify-content-center">

				<div class="col-md-6 col-lg-3 text-center" v-for="(item, index) in classesData" :key="index">
					<btn-classes
						:classData="item"
						@btn-cliccked="onButtonClick"
						@delete-class="onDeleteClass"
						class="mb-3"
					></btn-classes>
				</div>

			</div>
		</div>
		<div class="col-12 mt-4 mb-5">
			<add-class-component
				:school-type="schoolType"
				@on-added-class="getClassesData"
			></add-class-component>
		</div>

		<modal name="delete-modal"
			height="auto"
			:adaptive=true
			:maxWidth="400"
			id="root-msg-modal"
		>
			<div class="text-center">
				<p>Sei sicuro di eliminare la classe <strong>{{classToDelete.classe != 0 ? classToDelete.classe : ''}}{{classToDelete.sezione}}</strong> e gli eventuali elaborati ad essa associati?</p>

				<button class="btn btn-yellow rounded-pill px-3 py-0 mb-2 mr-2" @click.prevent="deleteClass"><span class="va-sub">Elimina classe</span></button>
				<button class="btn btn-secondary rounded-pill px-4 py-0 mb-2" @click.prevent="modalDeleteClose"><span class="va-sub">Annulla</span></button>
			</div>
		</modal>

		<modal name="msg-error-modal"
			height="auto"
			:adaptive=true
			:maxWidth="400"
			id="root-msg-modal"
		>
			<div class="text-center">
				<p>{{msgError}}</p>
				<button class="btn btn-secondary rounded-pill px-4 py-0 mb-2" @click.prevent="$modal.hide('msg-error-modal')"><span class="va-sub">Chiudi</span></button>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import BtnClasses from './BtnClasses.vue'
import AddClassComponent from './AddClassComponent.vue'

export default {
  components: { BtnClasses, AddClassComponent },
	name: 'RootClassesWorksComponent',
	props: ['surveyIsDone', 'schoolType'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			classesData: {},
			classToDelete: {},
			msgError: ''
		}
	},

	methods: {
		getClassesData() {
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_classes_data_list')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)

			axios.post(url, formData)
				.then((response) => {
					// console.log(response)
					this.classesData = response.data.items
				}, (error) => {
					console.log(error);
				});
		},

		onButtonClick(classItem) {
			this.$emit('btn-work-clicked', classItem)
		},

		onDeleteClass(classItem) {
			this.classToDelete = classItem
			this.$modal.show('delete-modal')
		},
		modalDeleteClose() {
			this.classToDelete = {}
			this.$modal.hide('delete-modal')
		},

		deleteClass() {
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_delete_class')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('class_id', this.classToDelete.id)

			axios.post(url, formData)
				.then((response) => {
					console.log(response)
					this.$modal.hide('delete-modal')
					if(response.data.error == '') {
						this.getClassesData()
					} else {
						this.msgError = response.data.error
						this.$modal.show('msg-error-modal')
					}
				}, (error) => {
					console.log(error);
				});
		}
	},

	mounted() {
		this.getClassesData()
	}
}
</script>
